module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-144x144-e92ae273ae77df72be1938739f9e43be.png";